import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, Logo, WooviLogo } from '@woovi/ui';

import type { PaymentCompanyLogo_company$key } from '../__generated__/PaymentCompanyLogo_company.graphql.ts';

type PaymentCompanyLogoProps = {
  company: PaymentCompanyLogo_company$key;
};

const PaymentCompanyLogo = (props: PaymentCompanyLogoProps): ReactNode => {
  const company = useFragment<PaymentCompanyLogo_company$key>(
    graphql`
      fragment PaymentCompanyLogo_company on Company {
        projectType
        logo {
          url(fitIn: true)
        }
      }
    `,
    props.company,
  );

  if (company?.logo?.url) {
    return (
      <BoxFlex
        sx={{
          justifyContent: 'center',
        }}
      >
        <Logo src={company?.logo?.url} />
      </BoxFlex>
    );
  }

  return <WooviLogo />;
};

export default PaymentCompanyLogo;
